import {
  DonationMatchType,
  DonationSummary,
  MonetaryAmount,
} from '../../types/__generated__';

type MatchingDonorDetails = {
  donorName: string;
  donorAvatar: string;
  amount: MonetaryAmount;
};

const getMatchedGivingSummary = (donationSummary: DonationSummary) =>
  donationSummary.totalMatched.find(
    match => match.type === DonationMatchType.ThirdParty,
  );

export const getIsMatchedGiving = (donationSummary?: DonationSummary | null) =>
  donationSummary ? Boolean(getMatchedGivingSummary(donationSummary)) : false;

export const getMatchedGivingDetails = (
  donationSummary?: DonationSummary | null,
): MatchingDonorDetails | null => {
  if (!donationSummary) return null;

  const matchingSummaryDetails = getMatchedGivingSummary(donationSummary);
  return matchingSummaryDetails
    ? {
        donorName: matchingSummaryDetails.matchingDonorName ?? '',
        donorAvatar: matchingSummaryDetails.matchingDonorAvatar ?? '',
        amount: matchingSummaryDetails.amount,
      }
    : null;
};
